import React, { Component } from 'react';
import { captchaService } from '../../services';
import i18n from '../../i18n';
import { CaptchaProps } from './iCaptcha';
import './captcha.scss';

interface CaptchaState {
  captchaId: string;
  base64Image: string;
  userEnteredCode: string;
}

class Captcha extends Component<CaptchaProps, CaptchaState> {
  public constructor(props: CaptchaProps) {
    super(props);
    this.state = {
      captchaId: this.generateId(),
      base64Image: '',
      userEnteredCode: ''
    };
  }

  public async componentDidMount(): Promise<void> {
    await this.loadCaptcha();
  }

  private generateId(): string {
    return Math.random().toString(36).substring(2, 15);
  }

  private async loadCaptcha(): Promise<void> {
    const result = await captchaService.getCaptcha(this.state.captchaId);
    this.setState({ base64Image: result.base64Image });
  }

  public async validateCaptcha(): Promise<boolean> {
    const postData = {
      userEnteredCaptchaCode: this.state.userEnteredCode,
      captchaId: this.state.captchaId
    };

    const validatedCaptcha = await captchaService.validateCaptcha(postData);

    if (validatedCaptcha.success === false) {
      this.refreshCaptcha();
      return false;
    }

    return true;
  }

  public refreshCaptcha(): void {
    const newId = this.generateId();
    this.setState({ captchaId: newId, userEnteredCode: '' }, () => {
      this.loadCaptcha();
    });
  }

  public render(): JSX.Element {
    return (
      <div className='col'>
        {this.state.base64Image && (
          <img
            src={`data:image/png;base64,${this.state.base64Image}`}
            alt='captcha'
            onClick={() => this.refreshCaptcha()}
            style={{ cursor: 'pointer' }}
          />
        )}
        {this.props.validatedCaptcha === false && <div className='captcha-error'>{i18n.t('login.captcha.error')}</div>}
        <input
          className='mt-2 mb-4 col login-form-captcha__input'
          id='yourFirstCaptchaUserInput'
          type='text'
          placeholder={i18n.t('login.captcha.placeholder')}
          value={this.state.userEnteredCode}
          onChange={(e) => this.setState({ userEnteredCode: e.target.value })}
        />
      </div>
    );
  }
}

export default Captcha;
